module.exports = __webpack_public_path__ + "img/result-detail-communication-outright01.9e7bbae8.svg";